import { Injectable } from '@angular/core';
import jwtDecode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor() {}

  /* Method to check the authentication status*/
  isAuthenticated(): boolean {
    var token = localStorage.getItem("idToken");
    return Boolean(token)
  }

  /* Method to get token data*/
  getTokenData(token: string): any {
    if(token){
      var decodeToken:any = jwtDecode(token)
      return decodeToken.payload;
    }
      return {}
  }
}
